import Dialog from '@material-ui/core/Dialog'
import { withStyles } from '@material-ui/core/styles'

export const CustomDialog = withStyles({
  paper: {
    minWidth: 300,
    maxWidth: 700,
  },
})(Dialog)
